import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PortDeleteConfirmData {
  title: string;
  message: string;
  subMessage?: string;
  vesselName?: any;
  vesselImo?: string | number;
  portName?: any;
  dates?: string;
  confirmText?: string;
  cancelText?: string;
  isDanger?: boolean;
}

@Component({
  selector: 'app-port-delete-confirm-popup',
  templateUrl: './port-delete-confirm-popup.component.html',
  styleUrls: ['./port-delete-confirm-popup.component.scss'],
})
export class PortDeleteConfirmPopupComponent {
  isDeleting = false;

  constructor(
    private dialogRef: MatDialogRef<PortDeleteConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PortDeleteConfirmData,
  ) {
    this.dialogRef.disableClose = false;
  }

  get displayVesselName(): string {
    const val = this.data?.vesselName;
    if (!val) return '';
    return String(Array.isArray(val) ? (val[0] ?? '') : val);
  }

  get displayPortName(): string {
    const val = this.data?.portName;
    if (!val) return '';
    return String(Array.isArray(val) ? (val[0] ?? '') : val);
  }

  onCancel(): void {
    if (!this.isDeleting) {
      this.dialogRef.close(false);
    }
  }

  onConfirm(): void {
    this.isDeleting = true;
    this.dialogRef.close(true);
  }
}
